//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ProCard',
  data() {
    return {}
  },
  props: ['goodInfo', 'changeVisible'],
  components: {},
  mounted() {

  },
  methods: {
    goToDetails(goodInfo) {
      if (goodInfo.stock > 0) {
        const id = goodInfo.id;
        this.$router.push({
          name: 'goodDetail',
          query: {
            id,
            cid: this.$route.query.cid
          }
        });
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/card/ProListCard.vue